import Choices from 'choices.js';
import { isBoolean } from 'lodash';
import 'choices.js/public/assets/styles/choices.min.css';

class Select {
  el;
  optionsEl;
  id;
  instance = null;
  options = {
    allowHTML: true,
    itemSelectText: '',
  };

  constructor(el, options) {
    this.el = el;
    this.optionsEl = this.el.querySelectorAll('option');
    this.id = this.el.dataset.id;
    this.options = {
      ...options,
      ...this.options,
    };
    this.instantiate(this.el, this.options);
    this.addEventListeners();
  }

  instantiate(el, options) {
    this.instance = new Choices(el, {
      ...options,
    });
  }

  refreshChoice(choice) {
    let choices = [];
    this.optionsEl.forEach((option) => {
      choices.push({
        value: option.value,
        label: option.innerText,
        selected: option.value === choice.value && isBoolean(choice.selected) ? choice.selected : !!option.selected,
        disabled: option.value === choice.value && isBoolean(choice.disabled) ? choice.disabled : !!option.disabled,
        customProperties: option.dataset.customProperties,
      });
    });
    this.instance.setChoices(
      choices,
      'value',
      'label',
      true,
    );
  }

  addEventListeners() {
    window.emitter.on('select:set-choice', ({ value, id }) => {
      if (!this.id || this.id !== id) return;
      this.instance.setChoiceByValue(value);
    });

    window.emitter.on('select:refresh-choice', ({ id, choice }) => {
      if (!this.id || this.id !== id) return;
      this.refreshChoice(choice);
    });
  }
}

export default Select;
